import BaseEntity from '../BaseEntity.model';

import { StatusEnum } from '../../Enum/StatusEnum';
import { CreatedBy } from '../Shared/CreatedBy.model';

export default interface IGAFScaleModel extends BaseEntity {
    MemberId: string;
    MemberName: string;
    CreatedDate: Date;
    CreatedBy: CreatedBy;
    UpdatedDate: Date;
    UpdatedBy: CreatedBy;
    GAFScore: string;
    IsAIGAFScore: boolean;
    GAFScaleComments: string;

    IsAssessmentCompleted: boolean;
    AssessmentStatus: StatusEnum;
}

export class GAFScaleModel implements IGAFScaleModel {
    Id: string;
    MemberId: string;
    MemberName: string;
    CreatedDate: Date;
    CreatedBy: CreatedBy;
    UpdatedDate: Date;
    UpdatedBy: CreatedBy;
    GAFScore: string;
    GAFScaleComments: string;

    IsAssessmentCompleted: boolean;
    AssessmentStatus: StatusEnum;
    IsAIGAFScore: boolean;

    constructor() {
        this.Id = '';
        this.MemberId = '';
        this.MemberName = '';
        this.GAFScore = '';
        this.GAFScaleComments = '';

        this.IsAssessmentCompleted = false;
        this.AssessmentStatus = 0;
    }
}
